import React from 'react';

import Accordion from 'src/components/elements/Accordion';

import { faqData } from './constants';

import styles from './FAQ.scss';

const FAQ = () => {
  return (
    <div className={styles.faq}>
      <div className={styles.faqTitle}>FAQ</div>
      <Accordion data={faqData} />
    </div>
  );
};

export default FAQ;
